import React from 'react'
import { Collapsible } from './ui/Collapsible'
import { PlaybackControls } from './controls/PlaybackControls'
import { TransformSection } from './controls/TransformSection'
import { TransitionSection } from './controls/TransitionSection'
import type { AnimationState, TransformState, TransitionType, SpringConfig, InertiaConfig } from '../types'

interface ControlPanelProps {
  state: AnimationState
  progress: number
  onTransformChange: (payload: Partial<TransformState>) => void
  onTransitionTypeChange: (type: TransitionType) => void
  onSpringChange: (payload: Partial<SpringConfig>) => void
  onTweenDurationChange: (duration: number) => void
  onTweenEaseChange: (ease: string) => void
  onInertiaChange: (payload: Partial<InertiaConfig>) => void
  onPlay: () => void
  onReset: () => void
}

export function ControlPanel({
  state,
  progress,
  onTransformChange,
  onTransitionTypeChange,
  onSpringChange,
  onTweenDurationChange,
  onTweenEaseChange,
  onInertiaChange,
  onPlay,
  onReset,
}: ControlPanelProps) {
  return (
    <aside className="w-80 border-r border-gray-200 bg-white flex flex-col">
      <div className="p-4 border-b border-gray-200">
        <PlaybackControls
          isPlaying={state.isPlaying}
          onPlay={onPlay}
          onReset={onReset}
        />
      </div>

      <div className="flex-1 overflow-y-auto">
        <Collapsible title="Transform" defaultOpen>
          <TransformSection
            transform={state.transform}
            onChange={onTransformChange}
          />
        </Collapsible>

        <Collapsible title="Transition" defaultOpen>
          <TransitionSection
            transition={state.transition}
            progress={progress}
            onTypeChange={onTransitionTypeChange}
            onSpringChange={onSpringChange}
            onTweenDurationChange={onTweenDurationChange}
            onTweenEaseChange={onTweenEaseChange}
            onInertiaChange={onInertiaChange}
          />
        </Collapsible>
      </div>
    </aside>
  )
}
